

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// inactivateLastTier
// INACTIVATELASTTIER
const INACTIVATELASTTIER= createAsyncThunk(
  "inactivateLastTier/inactivateLastTier",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const inactivateLastTierSlice = createSlice({
  name: "inactivateLastTierSlice",
  initialState: {
    inactivateLastTier: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfinactivateLastTier: (state) => {
        state.inactivateLastTier.loading = false
        state.inactivateLastTier.error = false
        state.inactivateLastTier.data = []
        state.inactivateLastTier.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(INACTIVATELASTTIER.fulfilled, (state, action) => {
      state.inactivateLastTier = {
        ...state.inactivateLastTier,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(INACTIVATELASTTIER.pending, (state, action) => {
      state.inactivateLastTier = {
        ...state.inactivateLastTier,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(INACTIVATELASTTIER.rejected, (state, action) => {
      state.inactivateLastTier = {
        ...state.inactivateLastTier,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const inactivateLastTierAction = {
    INACTIVATELASTTIER,
};

export { inactivateLastTierAction };
export default inactivateLastTierSlice.reducer;
export const {setInitialStateOfinactivateLastTier} = inactivateLastTierSlice.actions
